// import React from "react";
// import Report from "./Report";

// function MISReport({ type }) {

//     const reportArr = [[
//         { label: 'Summary Report', link: 'no-records' },
//         { label: 'Registration Report', link: 'viewApplications' },
//         { label: 'Payment Report', link: 'payment-details' },
//         { label: 'Online Payment Report', link: 'payment-details' },
//         { label: 'Application Report', link: 'application-details' },
//     ],
//     [
//         { label: 'EDCR Report', link: 'edcr-reports' },
//         { label: 'Private Professional Report', link: 'no-records' },
//         { label: 'Case Under Appendix-1(HPTCP Amendment Act 2016)', link: 'no-records' },
//         { label: 'Inward Report', link: 'inward-reports' },
//         { label: 'NOC Report', link: 'no-records' },
//     ],
//     [
//         { label: 'Audit Trial', link: 'no-records' },
//         { label: 'Pending Report', link: 'no-records' },
//         { label: 'Mobile Report', link: 'no-records' },
//         { label: 'Inspection Report', link: 'no-records' },
//         { label: 'Case Disposed Report', link: 'no-records' },
//     ],
//     [
//         { label: 'EKosh Payment Report', link: 'payment-dashboard' },
//         { label: 'Daily Visitor Tracker Report', link: 'no-records' },
//         { label: 'E-Charges Report', link: 'eCharges-details' },
//         { label: 'Unauthorized Construction Complaint Report', link: 'no-records' },
//         { label: 'Fast Track Report', link: 'no-records' },
//     ],
//     ]

//     return (
//         <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}>
//             {reportArr.map((element, index) => {
//                 return (
//                     <div key={index} style={{ flexBasis: '30%', marginBottom: '20px' }}>
//                         <Report report={element} index={index} />
//                     </div>
//                 )
//             })}
//         </div>
//     )
// }

// export default MISReport

import React, { useState, useEffect } from "react";
import Report from "./Report";

function MISReport({ tenantIdCodeOuter, type }) {
  const [filteredReportArr, setFilteredReportArr] = useState([]);
  const reportArr = [
    [
      { label: "Summary Report", link: "summary-reports" },
      { label: "Registration Report", link: "viewApplications" },
      { label: "Payment Report", link: "payment-details-report" },
      // { label: 'Online Payment Report', link: 'payment-details' },
      { label: "Application Report", link: "application-details" },
      { label: "Revenue Report", link: "revenue-details" }
      // { label: 'Proposal Wise Report', link: 'ulb-details' },
    ],
    // [
    //     { label: 'EDCR Report', link: 'edcr-reports' },
    //     { label: 'Private Professional Report', link: 'no-records' },
    //     { label: 'Case Under Appendix-1(HPTCP Amendment Act 2016)', link: 'no-records' },
    //     { label: 'Inward Report', link: 'inward-reports' },
    //     { label: 'NOC Report', link: 'no-records' },
    // ],
    // [
    //     { label: 'Audit Trial', link: 'no-records' },
    //     { label: 'Pending Report', link: 'no-records' },
    //     { label: 'Mobile Report', link: 'no-records' },
    //     { label: 'Inspection Report', link: 'inspection-report' },
    //     { label: 'Case Disposed Report', link: 'no-records' },
    // ],
    [
      // { label: 'EKosh Payment Report', link: 'payment-dashboard' },
      // { label: 'Average Time Taken Report', link: 'time-taken' },
      // { label: 'E-Charges Report', link: 'eCharges-details' },
      // { label: 'Unauthorized Construction Complaint Report', link: 'no-records' },
      // { label: 'Fast Track Report', link: 'risk-data-reports' },
    ],
  ];

  useEffect(() => {
    const updatedReportArr = reportArr.map((reportGroup) =>
      reportGroup.map((report) => {
        // Swap links of "Summary Report" and "Proposal Wise Report" when tenantIdCodeOuter === "UD"
        if (tenantIdCodeOuter === "UD") {
          if (report.label === "Summary Report") {
            return { ...report, link: "ulb-details" }; // Take "Proposal Wise Report" link
          }
          if (report.label === "Proposal Wise Report") {
            return { ...report, link: "no-records" }; // Take "Summary Report" link
          }
          if (report.label === "Application Report") {
            return { ...report, label: "Details Application Report" }; // Take "Summary Report" link
          }
        }
        return report; // Keep everything else unchanged
      })
    );

    setFilteredReportArr(updatedReportArr);
  }, [tenantIdCodeOuter]); // Runs when tenantIdCodeOuter changes

  console.log(filteredReportArr, tenantIdCodeOuter, "filteredReportArr111111111");

  return (
    <div>
      {/* {filteredReportArr.map((element, index) => {
                return (
                    <div key={index} style={{ flexBasis: '30%', marginBottom: '20px' }}>
                        <Report report={element} index={index} />
                    </div>
                )
            })} */}

      {filteredReportArr &&
        filteredReportArr?.map((element, index) =>
          element?.length > 0 ? (
            <div key={index} style={{ flexBasis: "30%", marginBottom: "20px" }}>
              <Report report={element} index={index} />
            </div>
          ) : null
        )}
    </div>
  );
}

export default MISReport;
